<template>
    <div class="alert alert-danger">
        <h5>
            <fa :icon="fas.faBan"/>
            {{$t('error.saving')}}
        </h5>
        <ul>
            <li v-for="(error, index) in errors.items" :key="index">
                {{ error.msg }}
            </li>
        </ul>
    </div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
    computed: {
        fas() {
			return fas;
		}
    }
}
</script>